module.exports = __webpack_public_path__ + "media/svg/pipe-1748bb0e.svg";